import React from 'react'

import Typography from '@material-ui/core/Typography'
import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core/styles'

import T from 'components/FormattedMessage'

interface Props {
}

const styles = (theme: Theme) => createStyles({
  root: {
    padding: theme.spacing() * 4,
    paddingTop: theme.spacing() * 12,
  }
})

type InjectedProps = Props & WithStyles<typeof styles>

const EventRankingEmptyState: React.SFC<InjectedProps> = ({ classes }) => (
  <div className={classes.root}>
    <Typography variant="h5" align="center">
      <T id="contests_ranking_empty_title" />
    </Typography>
    <Typography align="center" color="textSecondary">
      <T id="contests_ranking_empty_message" />
    </Typography>
  </div>
)

export default withStyles(styles)(EventRankingEmptyState)
